// make #main-navbar fixed to top when it reaches the top
var	elTop = jQuery('#site-header').offset().top;
	
jQuery(window).scroll(function() {
	jQuery('#site-header').toggleClass('infogroup-sticky-main-nav', jQuery(window).scrollTop() > elTop);
});